<template>
  <div class="changePassword">
    <div class="container">
      <form action="" class="fm">
        <h3>修改密码</h3>
        <div class="item">
          <span>旧密码</span>
          <input type="password" placeholder="请输入旧密码" v-model="oldPwd">
        </div>
        <div class="item">
          <span>密码</span>
          <input type="text" placeholder="请输入密码" v-model="pwd" v-if="bool">
          <input type="password" placeholder="请输入密码" v-model="pwd" v-else>
          <img src="../../assets/images/login/close.png" alt="" @click="open" v-if="bool">
          <img src="../../assets/images/login/open.png" alt="" @click="open" v-else>
        </div>
        <div class="item">
          <span>确认密码</span>
          <input type="text" placeholder="请确认密码" v-model="pwd2" v-if="bool2">
          <input type="password" placeholder="请确认密码" v-model="pwd2" v-else>
          <img src="../../assets/images/login/close.png" alt="" @click="open2" v-if="bool2">
          <img src="../../assets/images/login/open.png" alt="" @click="open2" v-else>
        </div>
        <button class="btn">提交</button>
      </form>
    </div>
  </div>
</template>

<script>
import '../../assets/css/login.less'
export default {
  data () {
    return {
      oldPwd: '', // 旧密码
      pwd: '', // 新密码
      pwd2: '', // 确认密码
      bool: false,
      bool2: false
    }
  },
  methods: {
    open () {
      this.bool = !this.bool
    },
    open2 () {
      this.bool2 = !this.bool2
    }
  }
}
</script>

<style scoped lang="less" type="text/less">
</style>



// WEBPACK FOOTER //
// src/pages/Login/ChangePassword.vue